import _ from 'underscore';
import { useEffect, useState } from 'react';
import { usePreference, preferenceNames } from '@bingads-webui-campaign-react/pmax-lite-data';
import { useWizardService, getCurrentStepId, getFlowFactor, getWizardData } from '@bingads-webui-react/wizard';
import { EVENTS } from '@bingads-webui-campaign-react/simplified-sign-up-suggestions';
import { ONBOARDING_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

import { useSuggestionsContext } from './suggestions-context';

export const SuggestionsResumer = () => {
  const { state } = useWizardService();
  const currentStepId = getCurrentStepId(state);
  const isSmartPage = getFlowFactor(state, 'isSmartPage');
  const { cache } = getWizardData(state);
  const { website: websiteFromCache } = cache || {};

  const [{ value: languagePreference }] = usePreference(preferenceNames.SelectedLanguage);
  const [{ value: websitePreference }] = usePreference(preferenceNames.WebsiteUrl);
  const [{ value: smartPageUrlPreference }] = usePreference(preferenceNames.SmartPageUrl);
  const urlForSuggestionService = isSmartPage ? smartPageUrlPreference : (websitePreference || websiteFromCache);

  const [isSuggestionInitialized, setIsSuggestionInitialized] = useState(false);
  const { send, isInitState } = useSuggestionsContext();

  useEffect(() => {
    if (!isSuggestionInitialized && isInitState && languagePreference
      && !_.contains(ONBOARDING_PATHS, currentStepId)) {
      const suggestionsPayload = {
        isSmartMode: false,
        isPMaxLite: true,
        url: urlForSuggestionService,
        language: languagePreference,
      };

      setIsSuggestionInitialized(true);
      send(EVENTS.LOAD, suggestionsPayload);
    }
  }, [currentStepId, isInitState, isSuggestionInitialized, languagePreference, send, urlForSuggestionService]);

  return null;
};
